import Loadable from '../../components/Loadable/Loadable'
import React, { lazy } from 'react'
import { Page } from '../../Pages'

const ContactPage = Loadable(lazy(() => import('./ContactPage')))

const contactRoutes = [
	{
		path: Page.contact.path,
		element: <ContactPage />
	}
]

export default contactRoutes
